import {Autocomplete, Box, InputAdornment} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import styles from '../../styles/components/clientdetails/clientDetailsStyle.module.scss';
import {AurTextField} from '../common/aur-text-field/AurTextField';
import {ReactComponent as InfoIcon} from '../../assests/svg/info-outlined-red.svg';
import {ReactComponent as DropdownIcon} from '../../assests/svg/down-triangle.svg';
import '../../styles/styles.scss';
import React, {useRef, useState} from 'react';
import {
  IDepartmentForm,
  Branch,
  IFormField,
  IValidation,
} from '../../types/client-management/departmentTypes';
import {t} from 'i18next';
import {MAX_CHAR, MAX_CHAR_LIMIT} from '../../constants/constants';
type AurDepartmentFormProps = {
  departmentFormData: IDepartmentForm;
  branches: Branch[];
  setDepartmentFormData: (fieldData: IFormField) => void;
  onEditMode?: boolean;
  isValidationAcive?: boolean;
  headerLabel?: string;
  saveBtnLabel?: string;
  noSaveButtonClickHandler: () => void;
  SaveButtonClickHandler: () => void;
  setBtnDisable: React.Dispatch<React.SetStateAction<boolean>>;
  btnDisable: boolean;
  nameValidation: IValidation;
  descriptionValidation: IValidation;
  branchValidation: IValidation;
};

const AurDepartmentForm: React.FC<AurDepartmentFormProps> = ({
  departmentFormData,
  branches,
  onEditMode = false,
  setDepartmentFormData,
  setBtnDisable,
  nameValidation,
  descriptionValidation,
  branchValidation,
}) => {
  const [filedFocusedType, setFiledFocusedType] = useState<'tab' | 'mouse'>(
    'tab'
  );
  const isFocusedByMouse = useRef(false);

  const selectChangeHandler = (
    event: React.SyntheticEvent,
    newValue: Branch
  ) => {
    setBtnDisable(!departmentFormData.name.trim());
    setDepartmentFormData({name: 'branch', value: newValue});
  };

  const nameChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBtnDisable(
      !(departmentFormData.branch?.clientBranchId && e.target.value.trim())
    );
    setDepartmentFormData({name: 'name', value: e.target.value});
  };

  const descriptionChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBtnDisable(
      !(
        departmentFormData.branch?.clientBranchId &&
        departmentFormData.name.trim()
      )
    );
    setDepartmentFormData({name: 'description', value: e.target.value});
  };

  const borderClass =
    filedFocusedType == 'tab' ? 'tabFocusedBorder' : 'mouseFocusedBorder';

  return (
    <Box>
      <Grid container>
        <Grid xs={7}>
          <Box className="margin-top-32">
            <AurTextField
              error={nameValidation?.isError}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {nameValidation?.isError && <InfoIcon />}
                  </InputAdornment>
                ),
              }}
              name="name"
              ariaLabel={t('addEditTeamMember.form.name')}
              onChange={nameChangeHandler}
              value={departmentFormData.name}
              helperText={nameValidation?.helperText}
              inputProps={{
                'data-testid': 'department-name-input',
                maxLength: MAX_CHAR_LIMIT,
              }}
              label={t('addEditTeamMember.form.name')}
              variant="filled"
              className={`aur-textfield custom-text-field email-text-field ${styles.fieldFocused}`}
            />
          </Box>
          <Box className="margin-top-48">
            <AurTextField
              error={descriptionValidation?.isError}
              name="description"
              inputProps={{
                'data-testid': 'department-description-input',
                maxLength: MAX_CHAR,
              }}
              onChange={descriptionChangeHandler}
              value={departmentFormData.description}
              helperText={
                descriptionValidation?.isError
                  ? descriptionValidation.validationText[
                      descriptionValidation.validationName
                    ]
                  : descriptionValidation?.helperText
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {descriptionValidation?.isError && <InfoIcon />}
                  </InputAdornment>
                ),
              }}
              label={t('addEditTeamMember.form.description')}
              ariaLabel={t('addEditTeamMember.form.description')}
              variant="filled"
              multiline
              minRows={1}
              maxRows={5}
              className={`aur-description-textfield custom-text-field description-text-field-width ${styles.fieldFocused}`}
            />
          </Box>
          <Box className="margin-top-18">
            {!onEditMode && (
              <Autocomplete
                popupIcon={<DropdownIcon />}
                disabled={onEditMode}
                blurOnSelect
                disableClearable
                options={branches}
                getOptionLabel={(option) => option.name ?? ''}
                isOptionEqualToValue={(option: Branch, value: Branch) =>
                  option.clientBranchId === value.clientBranchId
                }
                value={departmentFormData.branch}
                onChange={selectChangeHandler}
                onFocus={(_e: any) => {
                  if (isFocusedByMouse.current) {
                    isFocusedByMouse.current = false;
                    return;
                  }
                  setFiledFocusedType('tab');
                }}
                renderInput={(props) => (
                  <AurTextField
                    {...props}
                    error={branchValidation?.isError}
                    label={t('addEditTeamMember.form.branch')}
                    variant="filled"
                    className={`aur-textfield custom-text-field email-text-field ${borderClass}`}
                    ariaLabel={t('addEditTeamMember.form.branch')}
                    helperText={
                      branchValidation?.isError
                        ? branchValidation.validationText[
                            branchValidation.validationName
                          ]
                        : branchValidation?.helperText
                    }
                    onMouseDown={(_e: any) => {
                      isFocusedByMouse.current = true;
                      setFiledFocusedType('mouse');
                    }}
                    data-testid="branch-textfield"
                  />
                )}
              />
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AurDepartmentForm;
